import React, { useState, useEffect } from 'react';

const CookieConsent = () => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const consent = localStorage.getItem('posthog_consent');
        if (consent === null) {
            setIsVisible(true);
        }
    }, []);

    const handleAccept = () => {
        localStorage.setItem('posthog_consent', 'true');
        setIsVisible(false);
        // Refresh to initialize PostHog globally from index.js
        window.location.reload();
    };

    const handleDecline = () => {
        localStorage.setItem('posthog_consent', 'false');
        setIsVisible(false);
        if (window.posthog) {
            window.posthog.opt_out_capturing();
        }
        // Refresh to apply opt-out logic cleanly
        window.location.reload();
    };

    if (!isVisible) return null;

    return (
        <div className="fixed bottom-0 left-0 w-full z-50 p-4 font-sans">
            <div className="max-w-4xl mx-auto bg-black/80 backdrop-blur-md border border-gray-800 rounded-xl p-6 flex flex-col sm:flex-row items-center justify-between gap-4 shadow-2xl">
                <p className="text-white text-sm font-light tracking-wide m-0 text-center sm:text-left">
                    We use cookies to analyze site traffic and improve your experience.
                </p>
                <div className="flex gap-4 shrink-0">
                    <button 
                        onClick={handleDecline}
                        className="px-6 py-2 rounded-lg text-white border border-gray-600 hover:bg-gray-800 transition-colors text-xs font-bold tracking-widest uppercase"
                    >
                        Decline
                    </button>
                    <button 
                        onClick={handleAccept}
                        className="px-6 py-2 rounded-lg bg-white text-black hover:bg-gray-200 transition-colors text-xs font-bold tracking-widest uppercase"
                    >
                        Accept
                    </button>
                </div>
            </div>
        </div>
    );
};

export default CookieConsent;
